import {SmartComponent} from "smart-component-js";
import Swiper, {Navigation, Pagination} from "swiper";

class EditorialCarouselComponent extends SmartComponent {

    constructor(element, parentComponent, params) {
        super(element, parentComponent, params);
        this.element = element;
        this.swiper = this.element.parentElement;
        this.slidesPerViewCustom = this.element.dataset.slidesPerView ? parseInt(this.element.dataset.slidesPerView) : 1.2;
        this.init();
    }

    addSwiperStructure() {
        this.swiper.classList.add('swiper');
        this.element.classList.add('swiper-wrapper');
        const slides = this.swiper.querySelectorAll('.swiper-wrapper > .yxpRow');
        slides.forEach((slide) => slide.classList.add('swiper-slide'));
        this.slidesLength = slides.length;
        this.swiper.insertAdjacentHTML('beforeend', `
            <div class="swiper-button-prev"></div>
            <div class="swiper-pagination"></div>
            <div class="swiper-button-next"></div>
        `);
    }

    initSwiper() {
        new Swiper(this.swiper, {
            slidesPerView: (this.slidesLength > 1) ? this.slidesPerViewCustom : 1,
            spaceBetween: 20,
            breakpoints: {
                768: {
                    slidesPerView: this.slidesLength > 2 ? 2 : this.slidesLength
                },
                1024: {
                    slidesPerView: this.slidesLength > 3 ? 3 : this.slidesLength
                }
            },
            modules: [Navigation, Pagination],
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
                type: 'bullets'
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            },
        });
    }

    init() {
        this.addSwiperStructure();
        this.initSwiper();
    }
}

export default EditorialCarouselComponent;